const getPos = async ({ params, api }) => {
  return await api(`pos/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getPos;
